import styled from 'styled-components';

import { Drawer } from '#src/atoms/layout/Drawer/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import type { Props as SocialShareContentProps } from '#src/components/user/SocialShare/Content/index.tsx';
import { SocialShareContent } from '#src/components/user/SocialShare/Content/index.tsx';
import { useIsDesktopAndAbove } from '#src/hooks/device/useIsDesktopAndAbove.ts';

const Wrapper = styled.div`
  background-color: var(--c-nd-100-opaque);
  border-radius: var(--double-unit) var(--double-unit) 0 0;
`;

type Props = SocialShareContentProps & {
  opened: boolean;
  close: () => void;
};

export const SocialShareDialog = ({ opened, close, ...rest }: Props) => {
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const content = <SocialShareContent skip={!opened} {...rest} />;

  if (isDesktopAndAbove) {
    return (
      <Dialog onClose={close} open={opened} maxWidth="sm" fullWidth hideHeader>
        {content}
      </Dialog>
    );
  }

  return (
    <Drawer onBackdropClick={close} open={opened} side="bottom">
      <Wrapper>{content}</Wrapper>
    </Drawer>
  );
};
